import { createSlice } from "@reduxjs/toolkit";

export const stepSlice = createSlice({
  name: "step",
  initialState: {
    step: null,
    active_step: [],
    current_index: null,
  },
  reducers: {
    changeStep: (state, action) => {
      state.step = action.payload;
    },
    setCurrentIndex: (state, action) => {
      state.current_index = action.payload;
    },
    setActiveStep: (state, action) => {
      state.active_step = action.payload;
    },
  },
});

export const { changeStep } = stepSlice.actions;
export const { setCurrentIndex } = stepSlice.actions;
export const { setActiveStep } = stepSlice.actions;
export const selectStep = (state: any) => state.step.step;
export const selectCurrentIndex = (state: any) => state.step.current_index;
export const selectActiveStep = (state: any) => state.step.active_step;
export default stepSlice.reducer;
